function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

const SvgHamburger = (_ref) => {
  let svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 768 504",
    width: "5em",
    height: "5em",
    className: "openmenu",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("line", {
    id: "top",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 81,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 96,
    y1: 42,
    x2: 672,
    y2: 42
  }), /*#__PURE__*/React.createElement("line", {
    id: "mid",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 81,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 96,
    y1: 258,
    x2: 672,
    y2: 258
  }), /*#__PURE__*/React.createElement("line", {
    id: "bot",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 81,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    x1: 96,
    y1: 462,
    x2: 672,
    y2: 462
  }));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHamburger, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hamburger.57603a1a.svg";
export { ForwardRef as ReactComponent };